import { LoadingDots } from '@carboncopyco/ui';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FormProvider } from 'react-hook-form';
import { useEditTransactionRuleContext } from '../../EditTransactionRuleContext';
import { AdminForm } from './AdminForm';
import { UserForm } from './UserForm';

export const EditGeneralSettingsStep = () => {
  const { editorDataRulesAdmin } = useFlags();
  const { form } = useEditTransactionRuleContext();

  const FormComponent = editorDataRulesAdmin ? AdminForm : UserForm;

  return (
    <FormProvider {...form}>
      <div className="h-[656px]">
        {form.formState.isLoading ? (
          <div className="h-full flex flex-col justify-center items-center">
            <LoadingDots />
          </div>
        ) : (
          <FormComponent />
        )}
      </div>
    </FormProvider>
  );
};
